import { client } from '@/common-utils/libraries/axios/axios';
import CUSTOMIZATION from '../apiUrls';
import { replaceParameters } from '@/common-utils/functions/restUtils';

const mutationDeleteCustomization = (onSuccess, onError) => {
    return {
        mutationFn: ({ uuid }) => {
            return client.delete(replaceParameters(CUSTOMIZATION.DELETE_PACKAGE_CUSTOMIZATION.url, { uuid }));
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: () => {
            onSuccess();
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationDeleteCustomization;